module.exports = __webpack_public_path__ + "img/pw.cb805839.png";